import * as React from "react";
import { createGlobalStyle } from "styled-components";

import "./css/normalize.css";
import { Fonts } from "app/styling/fonts";

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-family: ${Fonts.FONT_FAMILY};
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    letter-spacing: 0.01em;
  }
  
  .qwiltTooltip.show {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1), 0 -2px 4px 0 rgba(0, 0, 0, 0.05);
    opacity: 1;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: bold;
  }
`;



// WEBPACK FOOTER //
// ./app/styling/AppGlobalStyle.tsx